"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var map_1 = require("../../store/reducers/map");
var SmokeLayerToggle_1 = __importDefault(require("./SmokeLayerToggle"));
var SmokeLayerToggleContainer = function () {
    var dispatch = react_redux_1.useDispatch();
    var isVisible = react_redux_1.useSelector(map_1.smokeLayerVisibleSelector);
    var smokeLayerCurrentTimeExtent = react_redux_1.useSelector(map_1.smokeLayerCurrentTimeExtentSelector);
    return (React.createElement(SmokeLayerToggle_1.default, { currentTime: smokeLayerCurrentTimeExtent === null || smokeLayerCurrentTimeExtent === void 0 ? void 0 : smokeLayerCurrentTimeExtent[0], isVisible: isVisible, onClick: function () {
            dispatch(map_1.smokeLayerVisibleToggled());
        } }));
};
exports.default = SmokeLayerToggleContainer;
